<template>
  <v-container>
    <v-row justify="center">
      <v-col
        cols="12"
        sm="10"
      >
        <v-card>
          <v-card-title>
            {{ this.job.number }} <br>
            {{ this.job.name}}
          </v-card-title>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="10"
      >
        <h2> Submissions </h2>
        <v-data-table
          :headers="getHeaders()"
          :items="submissions.results"
          :options.sync="options"
          :loading="loading"
          :items-per-page="25"
          :footer-props="{'items-per-page-options':[5, 10, 25, 50]}"
          :server-items-length="submissions.count"
          show-expand
          class="elevation-1"
        >
          <template #item.weekWorked="{ item }">
            {{ toReadableDate(item.weekWorked) }}
          </template>
          <template v-slot:expanded-item="{ item }">
            <td
              class="py-3"
              colspan="12"
            >
              <h3>
                {{ `${item.firstName} ${item.lastName}` }}
              </h3>
              <v-row
                no-gutters
                wrap
              >
                <v-col
                    cols="12"
                    class="mb-4"
                    md="4"
                >
                  <v-card
                    flat
                    tile
                    class="pa-2"
                  >
                    <v-row no-gutters>
                      <v-col cols="12">
                        <b> Created At: </b> {{ toReadableDate(item.createdAt) }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Position: </b> {{ `${item.jobTitle}` }}
                      </v-col>
                      <v-col
                        cols="12"
                      >
                        <b> Union: </b> {{ `${item.union}` }}
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col
                    cols="12"
                    class="mb-4"
                    md="4"
                >
                  <v-card
                    flat
                    tile
                    class="pa-2"
                  >
                    <v-row no-gutters>
                      <v-col cols="12">
                        <b> Rate: </b> {{ `$${item.rate}` }}
                      </v-col>
                      <v-col cols="12">
                        <b> Rate Type: </b> {{ `${item.rateType}` }}
                      </v-col>
                      <v-col cols="12">
                        <b> Phone: </b> {{ `${item.phone}` }}
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col
                    cols="12"
                    class="mb-4"
                    md="4"
                    v-if="item.totalPayout!=null"
                >
                  <v-card
                    flat
                    tile
                    class="pa-2"
                  >
                    <v-row no-gutters>
                      <v-col cols="12">
                        <b> Total Payout: </b> {{ `$${item.totalPayout}` }}
                      </v-col>
                      <v-col cols="12">
                        <b> Payout Description: </b> {{ `${item.payoutDescription}` }}
                      </v-col>
                      <v-col cols="12">
                        <b> Meal Penalty Amount: </b> {{ `$${item.totalMealPenaltyAmount}` }}
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import rules from '../utils/rules';
import { getJob } from '../services/jobs';
import { getJobSubmissions } from '../services/submissions';
import UserSelector from '../components/UserSelector.vue';
import CompanySelector from '../components/CompanySelector.vue';
import { DateTime } from 'luxon';

export default {
  components: {
    UserSelector,
    CompanySelector,
  },
  props: {
    mode: {
      type: String,
      default: 'EDIT',
    },
  },
  data() {
    return {
      loading: false,
      options: {},
      job: {
        notes: '',
        manager: {},
        artCoordinator: {},
        users: [
          {
            id: '',
            list: [],
          },
        ],
        endsOn: '',
        hasPaid: false,
        isNdaIncluded: false,
        payrollProvider: '',
        price: '',
      },
      rules,
      submissions: {},
      user: {},
      headers: [
        { text: 'First Name', align: 'start', value: 'firstName' },
        { text: 'Last Name', align: 'start', value: 'lastName' },
        { text: 'Position', align: 'start', value: 'jobTitle' },
        { text: 'Week Ending', align: 'start', value: 'weekWorked' },
      ],
      headersInvoice: [
        { text: 'First Name', align: 'start', value: 'firstName' },
        { text: 'Last Name', align: 'start', value: 'lastName' },
        { text: 'Position', align: 'start', value: 'jobTitle' },
      ],
    };
  },
  watch: {
    search: {
      deep: true,
      async handler() {
        await this.updateCompanyList();
      },
    },
    options: {
      handler() {
        this.getSubmissions();
      },
      deep: true,
    },
  },
  async mounted() {
    const { data } = await getJob(this.$route.params.jobId);
    this.job = data;
    this.job.market = data?.market?.id;
    this.job.payrollProvider = data?.payrollProvider?.id;
    this.job.endsOn = DateTime.fromISO(this.job.endsOn).toFormat('yyyy-MM-dd');
    await this.getSubmissions();
    if (this.job.users.length === 0) {
      this.job.users = [{ id: '', list: [] }];
    }

    this.$nextTick(() => {
      this.job = JSON.parse(JSON.stringify(this.job));
    });

  },
  methods: {
    getHeaders() {
      return this.job?.payrollProvider === 3 ? this.headersInvoice : this.headers;
    },
    toReadableDate(isoString) {
      return DateTime.fromISO(isoString).toFormat('MM/dd/yyyy');
    },
    async getSubmissions() {
      let order = '';
      this.options?.sortBy.forEach(sortBy => {
        order += this.options?.sortDesc?.[0] ? sortBy : `-${sortBy}`
      })
      const jobSubmissions = await getJobSubmissions(this.$route.params.jobId,
              this.options?.page, this.options?.itemsPerPage, order);
      this.submissions = jobSubmissions.data;
    }
  },
};
</script>

<style>

</style>
